import { render, staticRenderFns } from "./SendPushNotifications.vue?vue&type=template&id=647b2b74"
import script from "./SendPushNotifications.vue?vue&type=script&lang=js"
export * from "./SendPushNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647b2b74')) {
      api.createRecord('647b2b74', component.options)
    } else {
      api.reload('647b2b74', component.options)
    }
    module.hot.accept("./SendPushNotifications.vue?vue&type=template&id=647b2b74", function () {
      api.rerender('647b2b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SendPushNotifications.vue"
export default component.exports